import { useState, useEffect } from 'react';
import { HeaderContainer, Title, StockInfo } from '../styles/HeaderStyles';
import { fetchData, getStockData } from "../utills/common.utills.js";

const Header = () => {
  const [stockData, setStockData] = useState({
    currentPrice: '',
    priceChange: '',
    percentChange: '',
    lastUpdated: ''
  });

  useEffect(() => {
    const updateInterval = 30 * 60 * 1000;

    const updateStockData = () => {
      fetchData().then(res => {
        setStockData(getStockData(res.data));
      }).catch(console.error);
    };

    updateStockData();
    const intervalId = setInterval(updateStockData, updateInterval);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <HeaderContainer>
      <Title>IBM (Alpha Vantage Demo)</Title>
      <StockInfo>Current Price: {stockData.currentPrice}</StockInfo>
      <StockInfo>Price Change: {stockData.priceChange}</StockInfo>
      <StockInfo>Percent Change: {stockData.percentChange}%</StockInfo>
      <StockInfo>Last Updated: {stockData.lastUpdated}</StockInfo>
    </HeaderContainer>
  );
};

export default Header;